// Lib
import React from 'react';
import { CSSTransitionGroup } from '../../../node_module_clones/react-transition-group';

// Components
import Icon from '../../components/icons/Icon';

// Utils
import classNames from 'classnames';

// Styles
import './TaskDeleteButton.scss';

interface TaskDeleteButtonProps {
    show: boolean;
    elementId: string;
    className: string;
    moveToTrashHandler: (args: { elementId: string }) => void;
}

class TaskDeleteButton extends React.Component<TaskDeleteButtonProps> {
    moveToTrash = (event: React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>) => {
        if (event.type === 'pointerup' && (event as React.MouseEvent).button !== 0) return; // allow right- and middle-click to do their usual thing

        event.stopPropagation();
        event.preventDefault();

        const { elementId, moveToTrashHandler } = this.props;

        return moveToTrashHandler({ elementId });
    };

    render() {
        const { show, className } = this.props;

        const component = show ? (
            <div
                className={classNames('TaskDeleteButton', 'task-utility-button', className)}
                onPointerUp={this.moveToTrash}
            >
                <div className="background" />
                <Icon name="task-trash" />
            </div>
        ) : null;

        return (
            <div className="delete-button-container">
                <CSSTransitionGroup
                    transitionName="slide"
                    transitionAppear
                    transitionAppearTimeout={200}
                    transitionEnterTimeout={200}
                    transitionLeaveTimeout={200}
                >
                    {component}
                </CSSTransitionGroup>
            </div>
        );
    }
}

export default TaskDeleteButton;
